import * as actions from '../actionTypes'

const initialState = {
    transNum: '',
    transId: '',
    emailAddress: '',
    transOwner: ''
}

export const SET_CONFIRMATION_DATA = "SET_CONFIRMATION_DATA"
export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CONFIRMATION_DATA:
            return {
                ...state,
                ...action.payload,
            }
        case actions.CLEAR_ALL: {
            return initialState
        }
        default:
            return state
    }
}

export const setConfirmationData = (data) => {
    return {
        type: SET_CONFIRMATION_DATA,
        payload: data
    }
}